// Chicago — ported verbatim from GolfGamesScorecard's calcChicago
// (utils/scoring.ts). Points vs par per hole: double eagle 8 · eagle 5 ·
// birdie 2 · par 1 · bogey+ 0. Standard quota = 39 − handicap; result is
// points over/under quota, sorted best-first. The handicap lives in the quota,
// so scoring uses GROSS scores (no separate net toggle) — same as the live app.
export function calcChicago(players, pars) {
  return (players || [])
    .map((p) => {
      const pointsByHole = p.scores.map((s, i) => {
        if (s === null || s === undefined) return 0
        const diff = s - (pars[i] ?? 4)
        if (diff <= -3) return 8 // double eagle (albatross)
        if (diff === -2) return 5 // eagle
        if (diff === -1) return 2 // birdie
        if (diff === 0) return 1 // par
        return 0 // bogey or worse
      })
      const total = pointsByHole.reduce((s, v) => s + v, 0)
      const quota = Math.max(0, 39 - (p.handicap || 0))
      return { ...p, pointsByHole, total, quota, vsQuota: total - quota }
    })
    .sort((a, b) => b.vsQuota - a.vsQuota)
}
